/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantRequestAccessSpec { 
    /**
     * Cloud Provider Region ID
     */
    region: string;
    /**
     * Name of person/company requesting access
     */
    requested_by_name?: string;
}

